import base from './base' // 导入接口域名列表
import axios from '@/utils/http' // 导入http中创建的axios实例
import qs from 'qs' // 根据需求是否导入qs模块

const user = {
  // 新闻详情,演示
  articleDetail (id, params) {
    return axios.get(`${base.url}/mock`, {
      params: params
    })
  },
  login (params) {
    return axios.post(`${base.url}/user/login`, params)
  },
  isBind (params) {
    return axios.post(`${base.url}/user/isMobileBind`, params)
  },
  unBind(params){
    return axios.post(`${base.url}/user/mobileUnBind`, params)
  },
  bind(params){
    return axios.post(`${base.url}/user/mobileBind`, params)
  },
  send(params){
    return axios.post(`${base.url}/user/sendVerificationCode`, params)
  },
  checkUser(params){
    return axios.post(`${base.url}/user/checkSingleUser`, params)
  },
}

export default user
